import React from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";

import Review from "./Review";
import { Container } from "./styled";

const ReviewsSlider = ({ reviewsData }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Container>
      <Slider {...settings}>
        {reviewsData.map((review, key) => (
          <div key={key}>
            <Review
              name={review.name}
              shortSummary={review.shortSummary}
              content={review.content}
            />
          </div>
        ))}
      </Slider>
    </Container>
  );
};

ReviewsSlider.propTypes = {
  reviewsData: PropTypes.array,
};

export default ReviewsSlider;
